"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSEUDOS_MAPPING = void 0;
exports.PSEUDOS_MAPPING = {
    hover: 'hover',
    focus: 'focus',
    'focus-within': 'focus-within',
    'focus-visible': 'focus-visible',
    active: 'active',
    visited: 'visited',
    target: 'target',
    'first-child': 'first',
    'last-child': 'last',
    'only-child': 'only',
    'nth-child(odd)': 'odd',
    'nth-child(2n+1)': 'odd',
    'nth-child(even)': 'even',
    'nth-child(2n)': 'even',
    'first-of-type': 'first-of-type',
    'last-of-type': 'last-of-type',
    'only-of-type': 'only-of-type',
    empty: 'empty',
    disabled: 'disabled',
    enabled: 'enabled',
    checked: 'checked',
    indeterminate: 'indeterminate',
    default: 'default',
    required: 'required',
    valid: 'valid',
    invalid: 'invalid',
    'in-range': 'in-range',
    'out-of-range': 'out-of-range',
    autofill: 'autofill',
    'read-only': 'read-only',
    before: 'before',
    after: 'after',
    'first-letter': 'first-letter',
    'first-line': 'first-line',
    marker: 'marker',
    selection: 'selection',
    'file-selector-button': 'file',
    backdrop: 'backdrop',
};
